import React, { useState } from "react";
import Auth from "./Auth";
import { useAuth } from "./../util/auth.js";

function SignIn(props) {
  const { onSignin, ...otherProps } = props;
  const auth = useAuth();
  const [status, setStatus] = useState({ type: "none" });

  const onSubmit = ({ email, pass }) => {
    setStatus({ type: "pending" });
    auth
      .signin(email, pass)
      .then(user => {
        onSignin && onSignin();
      })
      .catch(error => {
        setStatus({
          type: "error",
          message: error.message
        });
      });
  };

  return (
    <Auth
      mode="signin"
      onSubmit={onSubmit}
      status={status}
      {...otherProps}
    ></Auth>
  );
}

export default SignIn;
